import React from 'react'
import { Link } from 'react-router-dom';
import pic1 from '../assets/Macbook .png'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next';

function Prices({ scrollRef }) {
  const { t } = useTranslation();

  return (
    <div className="lg:h-fit w-full bg-prices-background bg-fixed bg-center bg-cover bg-no-repeat lg:p-16">
      <div className="flex flex-col-reverse gap-7 lg:gap-0 py-6 lg:py-0 lg:flex-row justify-between items-center mx-auto w-[80%] lg:w-auto ">
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0, x: -75 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}>
          <img src={pic1} alt="" />
        </motion.div>
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0, x: 75 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}
          className="text-right my-auto flex flex-col gap-6 lg:gap-10 text-white">
          <h1 className="lg:text-4xl text-center lg:text-right text-3xl font-bold pb-3 ">
            {/* الأســـــعـــــــار */}
            {t("prices.title")}
          </h1>
          <p className="lg:w-[40rem] lg:text-2xl lg:font-medium text-center lg:text-right">
            {/* تعرّف على أحدث الأسعار للمحاصيل المختلفة في السوق. يمكنك مراقبة
            التقلبات واتخاذ قرارات استراتيجية تعزز من ربحيتك */}
            {t("prices.description")}
          </p>
          <div className="flex justify-center lg:justify-start">
            <Link to="/home/prices">
              <div className="w-[11rem] bg-white text-center   text-primary font-bold p-3 rounded-[17.5px]">
                {/* إعرف المزيد */}
                {t("common.knowMore")}
              </div>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Prices